import React, { useState } from "react";
import { Phone, Mail, Pin } from "./icons";
import { sendContact } from "../api";

const initialState = { name: "", email: "", phone: "", message: "" };

export const Contact = ({ data }) => {
  const [form, setForm] = useState(initialState);
  const [state, setState] = useState({ sending: false, sent: false, error: null });

  const update = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();

    setState({ sending: true, sent: false, error: null });
    try {
      await sendContact(form);
      setForm(initialState);
      setState({ sending: false, sent: true, error: null });
    } catch (err) {
      setState({ sending: false, sent: false, error: err.message });
    }
  };

  return (
    <section id="contact" className="section contact">
      <div className="container contact-inner">
        <div className="contact-aside">
          <h2>Demander un devis</h2>
          <p>
            Une question, un trajet particulier, un déplacement régulier&nbsp;? Décrivez votre
            besoin, je vous réponds rapidement.
          </p>

          <ul className="contact-list">
            <li>
              <Phone size={18} />
              <a href={`tel:${data?.phoneLink || ""}`}>{data?.phone}</a>
            </li>
            <li>
              <Mail size={18} />
              <a href={`mailto:${data?.email || ""}`}>{data?.email}</a>
            </li>
            <li>
              <Pin size={18} />
              <span>{data?.availabilityLong}</span>
            </li>
          </ul>
        </div>

        <form className="contact-form" onSubmit={submit}>
          <div className="field-row">
            <label className="field">
              <span>Nom</span>
              <input
                type="text"
                name="name"
                placeholder="Votre nom"
                value={form.name}
                onChange={update}
                required
              />
            </label>
            <label className="field">
              <span>Téléphone</span>
              <input
                type="tel"
                name="phone"
                placeholder="06 00 00 00 00"
                value={form.phone}
                onChange={update}
              />
            </label>
          </div>

          <label className="field">
            <span>Email</span>
            <input
              type="email"
              name="email"
              placeholder="vous@exemple.fr"
              value={form.email}
              onChange={update}
              required
            />
          </label>

          <label className="field">
            <span>Votre demande</span>
            <textarea
              name="message"
              rows="5"
              placeholder="Date, trajet, nombre de passagers…"
              value={form.message}
              onChange={update}
              required
            />
          </label>

          <button type="submit" className="btn btn-primary btn-block" disabled={state.sending}>
            {state.sending ? "Envoi…" : "Envoyer ma demande"}
          </button>

          {state.sent && <p className="form-success">Message envoyé. À très vite !</p>}
          {state.error && <p className="form-error">{state.error}</p>}
        </form>
      </div>
    </section>
  );
};

export default Contact;
